<template>
    <div>
        <!-- Envio de Arquivo -->
        <template v-if="acao_anexar">
            <az-file-upload
                ref="upload"
                @refresh="carregar_arquivos()"
                :multiple="true"
                :arquivos="marcacao.arquivos"
                :parms="{ 
                    model_type: ( parm_model ? parm_model : 'marcacao' ), 
                    model_id: marcacao[parm_campo_id ? parm_campo_id : 'id_marcacao'] 
                }" />
        </template>      
    </div>
</template>

<script>
import AzFileUpload from '../../util/AzFileUpload.vue';

export default {
    data() { 
        return { 
            marcacao: null, 
            acao_anexar: false,
            parm_model: "", 
            parm_campo_id: "", 
        };
    },

    props: ['model', 'campo_id'],

    components: { 
        AzFileUpload,
    },

    methods: { 
        // Arquivos
        abrir_anexar_arquivo(marcacao, model = null, campo_id = null) { 
            this.parm_model = model ? model : this.model;
            this.parm_campo_id = campo_id ? campo_id : this.campo_id;

            this.marcacao = marcacao;
            this.acao_anexar = true;

            if ( this.marcacao.arquivos && this.marcacao.arquivos.length && !this.marcacao.arquivos.find(arq => arq.arquivo) ) { 
                this.carregar_arquivos(true);
                return;
            }

            this.$nextTick(() => { 
                this.$refs.upload.abrir();
            });
        },

        carregar_arquivos (abrir = false) { 

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                    id: this.marcacao[this.parm_campo_id ? this.parm_campo_id : 'id_marcacao'], 
                    type: this.parm_model ? this.parm_model : 'marcacao',
                }
            })
            .then(res => { 
                this.marcacao.arquivos = res;

                if ( abrir ) { 
                    this.$nextTick(() => { 
                    this.$refs.upload.abrir();
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

    }
}
</script>